const { useState, useEffect } = wp.element;
const { useBlockProps } = wp.blockEditor;
import { Flex, Icon, FlexBlock, SelectControl, __experimentalToggleGroupControl, __experimentalToggleGroupControlOptionIcon, TextControl, __experimentalUnitControl as UnitControl, FlexItem } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { menu, row, reusableBlock, stretchWide, justifySpaceBetween, justifyLeft, justifyRight, justifyCenter, justifyStretch, pullquote, handle } from '@wordpress/icons';
import './display.css';
import { setAttributesResponsive } from '../../block/functions.js';

export default function DisplayControl({ attributes, setAttributes }) {

    const currentDevice = useSelect((select) => {
        return select('core/edit-post').__experimentalGetPreviewDeviceType();
    }, []);
    const device = currentDevice.toLowerCase();
    const deviceString = device === 'desktop' ? '' : `:${device}`;

    return (
        <>
            <SelectControl
                label="Display"
                options={[
                    { label: 'Default', value: '' },
                    { label: 'Unset', value: 'unset' },
                    { label: 'Block', value: 'block' },
                    { label: 'Flex', value: 'flex' },
                    { label: 'Grid', value: 'grid' },
                    { label: 'Inline', value: 'inline' },
                    { label: 'Inline-block', value: 'inline-block' },
                    { label: 'Inline-flex', value: 'inline-flex' },
                    { label: 'None', value: 'none' },
                ]}
                labelPosition="edge"
                className="softlite-select-control"
                onChange={(newValue) => setAttributesResponsive('display', newValue, device, setAttributes, attributes)}
                value={attributes?.['display' + deviceString]}
            />
            {attributes?.display == 'grid' && (
                <>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Grid gap</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newGap) => setAttributesResponsive('grid-gap', newGap, device, setAttributes, attributes)}
                                value={attributes?.['grid-gap' + deviceString]}
                            />
                        </FlexBlock>
                    </Flex>
                    <TextControl
                        label="Grid template columns"
                        onChange={(newValue) => setAttributesResponsive('grid-template-columns', newValue, device, setAttributes, attributes)}
                        value={attributes?.['grid-template-columns' + deviceString]}
                        className='softlite-display-label-block'
                    />
                    <TextControl
                        label="Grid template rows"
                        onChange={(newValue) => setAttributesResponsive('grid-template-rows', newValue, device, setAttributes, attributes)}
                        value={attributes?.['grid-template-rows' + deviceString]}
                        className='softlite-display-label-block'
                    />
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Grid auto rows</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('grid-auto-rows', newValue, device, setAttributes, attributes)}
                                value={attributes?.['grid-auto-rows' + deviceString]}
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Grid auto flow</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('grid-auto-flow', newValue, device, setAttributes, attributes)}
                                value={attributes?.['grid-auto-flow' + deviceString]}
                            />
                        </FlexBlock>
                    </Flex>
                    <div className='softlite-toggle'>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Justify Items"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('justify-items', newValue, device, setAttributes, attributes)}
                            value={attributes?.['justify-items' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifySpaceBetween} size={18} />}
                                label="Space Between"
                                value="space-between"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Around"
                                value="space-around"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Evenly"
                                value="space-evenly"
                            />
                        </__experimentalToggleGroupControl>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Align Items"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('align-items', newValue, device, setAttributes, attributes)}
                            value={attributes?.['align-items' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Stretch"
                                value="stretch"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={pullquote} size={18} />}
                                label="Baseline"
                                value="baseline"
                            />
                        </__experimentalToggleGroupControl>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Justify Content"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('justify-content', newValue, device, setAttributes, attributes)}
                            value={attributes?.['justify-content' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifySpaceBetween} size={18} />}
                                label="Space Between"
                                value="space-between"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Around"
                                value="space-around"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Evenly"
                                value="space-evenly"
                            />
                        </__experimentalToggleGroupControl>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Align Content"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('align-content', newValue, device, setAttributes, attributes)}
                            value={attributes?.['align-content' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Stretch"
                                value="stretch"
                                className='softlite-toggle-control__button'
                            />
                        </__experimentalToggleGroupControl>
                    </div>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Order</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('order', newValue, device, setAttributes, attributes)}
                                value={attributes?.['order' + deviceString]}
                                placeholder="0"
                            />
                        </FlexBlock>
                    </Flex>
                </>
            )}
            {attributes?.display == 'flex' && (
                <>
                    <SelectControl
                        label="Flex wrap"
                        options={[
                            { label: 'Default', value: '' },
                            { label: 'No Wrap', value: 'nowrap' },
                            { label: 'Wrap', value: 'wrap' },
                            { label: 'Wrap Reverse', value: 'wrap-reverse' },
                        ]}
                        labelPosition="edge"
                        onChange={(newValue) => setAttributesResponsive('flex-wrap', newValue, device, setAttributes, attributes)}
                        value={attributes?.['flex-wrap' + deviceString]}
                        className="softlite-select-control"
                    />
                    <div className='softlite-toggle'>
                        <Flex className="softlite-toggle-option-direction">
                            <__experimentalToggleGroupControl
                                label="Direction"
                                isDeselectable
                                isBlock
                                onChange={(newValue) => setAttributesResponsive('flex-direction.direction', newValue, device, setAttributes, attributes)}
                                value={attributes?.['flex-direction' + deviceString]?.direction}
                            >
                                <__experimentalToggleGroupControlOptionIcon
                                    icon={<Icon icon={menu} size={18} />}
                                    label="Column"
                                    value="column"
                                />
                                <__experimentalToggleGroupControlOptionIcon
                                    icon={<Icon icon={row} size={18} />}
                                    label="Row"
                                    value="row"
                                />
                            </__experimentalToggleGroupControl>
                            <__experimentalToggleGroupControl
                                label=" "
                                isDeselectable
                                Deselectable
                                isBlock
                                onChange={(newValue) => setAttributesResponsive('flex-direction.isReverse', newValue, device, setAttributes, attributes)}
                                value={attributes?.['flex-direction' + deviceString]?.isReverse}
                            >
                                <__experimentalToggleGroupControlOptionIcon
                                    icon={<Icon icon={reusableBlock} size={18} />}
                                    label="Reverse"
                                    value='reverse'
                                />
                            </__experimentalToggleGroupControl>
                        </Flex>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Align Self"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('align-self', newValue, device, setAttributes, attributes)}
                            value={attributes?.['align-self' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={stretchWide} size={18} />}
                                label="Stretch"
                                value="stretch"
                            />
                        </__experimentalToggleGroupControl>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Justify Content"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('justify-content', newValue, device, setAttributes, attributes)}
                            value={attributes?.['justify-content' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifySpaceBetween} size={18} />}
                                label="Space Between"
                                value="space-between"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Around"
                                value="space-around"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Space Evenly"
                                value="space-evenly"
                            />
                        </__experimentalToggleGroupControl>
                        <__experimentalToggleGroupControl
                            className="softlite-toggle-control"
                            label="Align Items"
                            isDeselectable
                            isBlock
                            onChange={(newValue) => setAttributesResponsive('align-items', newValue, device, setAttributes, attributes)}
                            value={attributes?.['align-items' + deviceString]}
                        >
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyLeft} size={18} />}
                                label="Start"
                                value="flex-start"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyCenter} size={18} />}
                                label="Center"
                                value="center"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyRight} size={18} />}
                                label="End"
                                value="flex-end"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={justifyStretch} size={18} />}
                                label="Stretch"
                                value="stretch"
                                className='softlite-toggle-control__button'
                            />
                            <__experimentalToggleGroupControlOptionIcon
                                icon={<Icon icon={pullquote} size={18} />}
                                label="Baseline"
                                value="baseline"
                            />
                        </__experimentalToggleGroupControl>
                    </div>
                    <Flex style={{marginTop: '20px'}}>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Column gap</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('column-gap', newValue, device, setAttributes, attributes)}
                                value={attributes?.['column-gap' + deviceString]}
                                placeholder="Normal"
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Row gap</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('row-gap', newValue, device, setAttributes, attributes)}
                                value={attributes?.['row-gap' + deviceString]}
                                placeholder="Normal"
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Flex grow</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('flex-grow', newValue, device, setAttributes, attributes)}
                                value={attributes?.['flex-grow' + deviceString]}
                                placeholder="0"
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Flex shrink</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('flex-shrink', newValue, device, setAttributes, attributes)}
                                value={attributes?.['flex-shrink' + deviceString]}
                                placeholder="1"
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Flex basis</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('flex-basis', newValue, device, setAttributes, attributes)}
                                value={attributes?.['flex-basis' + deviceString]}
                                placeholder="auto"
                            />
                        </FlexBlock>
                    </Flex>
                    <Flex>
                        <FlexBlock style={{ marginBottom: '12px' }}>
                            <label>Order</label>
                        </FlexBlock>
                        <FlexBlock>
                            <TextControl
                                onChange={(newValue) => setAttributesResponsive('order', newValue, device, setAttributes, attributes)}
                                value={attributes?.['order' + deviceString]}
                                placeholder="0"
                            />
                        </FlexBlock>
                    </Flex>
                </>
            )}
        </>
    );
}